module.exports = __webpack_public_path__ + "static/media/Bitbucket.f66a243b.png";